export const formatThousands = (value: number) => {
  if (value == null) return '';
  return value?.toLocaleString('en-US', { maximumFractionDigits: 0 });
};

const removeThousandSeparator = (value: string) => {
  return value.replace(/,/g, '');
};

export const tryFormatThousands = (value: unknown, fallback = '') => {
  if (value == null) return fallback;
  if (typeof value === 'string') {
    // Remove thousand separator to safely convert to number
    const numberValue = Number(removeThousandSeparator(value));
    if (isNaN(numberValue)) return fallback;
    return formatThousands(numberValue);
  }
  if (typeof value === 'number') {
    return formatThousands(value);
  }
  return fallback;
};

export const percentFormatter = (n: number, toFix?: number) =>
  new Intl.NumberFormat().format(Number((n * 100).toFixed(toFix))) + '%';

export const formatUSD = (money: number | undefined) => {
  if (money == null) return '';
  return `${money?.toLocaleString('en-US', { maximumFractionDigits: 2 })} USD`;
};
